/*
 * Copyright (c) 2020.
 * Simon
 */

import {SERVER_API_PLATFORMJK} from '../../constans/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";
import {
    HEAR_UPDATE_FAILURE,
    HEAR_UPDATE_REQUEST,
    HEAR_UPDATE_SUCCESS
} from "../../types/index";

/**
 * HearUpdateAction
 */
const HearUpdateAction = (hearId, fanpageId, hearData, actor = null) => ({


    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_PLATFORMJK}/api/hears/${hearId}`
        },
        method: "PUT",
        headers: (headers()),
        body: (() => {
            return JSON.stringify(hearData);
        }),
        types: [
            HEAR_UPDATE_REQUEST,
            {
                type: HEAR_UPDATE_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "actor": actor,
                        "action_type": HEAR_UPDATE_SUCCESS,
                        "fanpage_id": fanpageId,
                        "data": data,
                    }
                }
            },
            {
                type: HEAR_UPDATE_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "action_type": HEAR_UPDATE_FAILURE,
                        "actor": actor,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {HearUpdateAction}

